import { render } from "./LightboxPhones.vue?vue&type=template&id=0a0ee3d4"
import script from "./LightboxPhones.vue?vue&type=script&lang=js"
export * from "./LightboxPhones.vue?vue&type=script&lang=js"

import "./LightboxPhones.vue?vue&type=style&index=0&id=0a0ee3d4&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__